import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const Surveys = () => {
  const options: ApexOptions = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: { show: false },
      fontFamily: `'Poppins', sans-serif`,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 6,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#A78BFA", "#8B5CF6", "#6D28D9"],
    xaxis: {
      categories: ["", "", ""],
      labels: {
        style: {
          fontSize: "1rem",
          fontFamily: `'Poppins', sans-serif`,
          colors: "#666666",
        },
      },
      axisTicks: {
        show: false, // <-- Hide x-axis ticks here
      },
    },

    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        style: {
          fontSize: "1rem",
          fontFamily: `'Poppins', sans-serif`,
          colors: "#666666",
        },
      },
    },
    legend: {
      position: "bottom",
      fontSize: "14px",
      markers: {
        size: 10,
        shape: "square",
      },
      fontFamily: `'Poppins', sans-serif`,
      labels: {
        colors: "#666666",
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      style: {
        fontFamily: `'Poppins', sans-serif`,
      },
    },
    grid: {
      borderColor: "#e7e7e7",
      strokeDashArray: 3,
    },
  };

  const series = [
    {
      name: "Satisfaction (%)",
      data: [],
    },
    {
      name: "Response Rate (%)",
      data: [],
    },
    {
      name: "Improvement (%)",
      data: [80, 60, 40],
    },
  ];

  return (
    <div className="survey_sec">
      <div className="qep_grad">
        <h2>Survey Results</h2>
        <p>
          These summaries will be compiled automatically from the survey
          component.
        </p>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <div className="survey_chart mb-4">
            <div className="qep_grad">
              <h2>Participant Survey</h2>
            </div>
            <Chart options={options} series={series} type="bar" height={300} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="survey_chart mb-4">
            <div className="qep_grad">
              <h2>Employee Survey</h2>
            </div>
            <Chart options={options} series={series} type="bar" height={300} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="survey_chart mb-4 mb-lg-0">
            <div className="qep_grad">
              <h2>Provider Survey</h2>
            </div>
            <Chart options={options} series={series} type="bar" height={300} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="survey_chart">
            <div className="qep_grad">
              <h2>Stakeholder Survey</h2>
            </div>
            <Chart options={options} series={series} type="bar" height={300} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Surveys;
